module.exports = "../images/cabin1.jpg?v=ecb85a8";